<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">ライセンスの確認</span>
        </div>
        <div class="popup-content">
          <div class="list03 license-list" style="max-height:270px;">
            <ul>
              <li v-for="(product, index) in user.products" :key="'product_' + index">
                <p class="list03-label">{{product.name}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>s

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAccountViewLicense } from '@/logic/contract/ContractAccountViewLicense'

export default defineComponent({
  name: 'PCContractAccountViewLicense',
  setup (props, context) {
    return { ...ContractAccountViewLicense(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 0 0 40px!important;
}
.popup-container {
  top: 50%;
  transform: translate3d(50%,-50%,0);
}
.license-list {
  padding: 40px;
  color: $color-content;
  overflow-y: auto;
  li {
    padding-left: 0;
  }
}
</style>
